import Register from './containers/Register';
import withRole from '../../hocs/withRole';
import './vehicles.css';

export default [{
  path: '/vehicles',
  exact: true,
  component: withRole('*', Register),
}];
